export default {
  tabIndex: {
    generalTab: 'Thông tin chung',
    detailTab: 'Chi tiết',
  },
  generalTab: {
    proposalNumber: 'Số giấy đề nghị',
    projectName: 'Tên dự án',
    projectCode: 'Mã dự án',
    inventorRepresentative: 'Đại diện chủ đầu tư / Ban QLDA',
    qhnsCode: 'Mã QHNS',
    inventorAccountNumber: 'Số tài khoản chủ đầu tư',
    domesticCapital: 'Vốn trong nước',
    foreignCapital: 'Vốn ngoài nước',
    place: 'Tại',
    contractBase: 'Căn cứ hợp đồng',
    date: 'Ngày',
    appendixContract: 'Phụ lục bổ sung hợp đồng số',
    baseApproveEstimate: 'Căn cứ quyết định phê duyệt dự toán số',
    baseKlht: 'Căn cứ bảng xác định giá trị KLHT số',
    accumKlnt: 'Lũy kế giá trị KLNT của hạng mục đề nghị thanh toán',
    overbalance: 'Số dư tạm ứng của hạng mục đề nghị thanh toán đến kỳ này',
    moneySuggestion: 'Số tiền đề nghị',
    advance: 'Tạm ứng',
    pay: 'Thanh toán',
    fundSouce: 'Thuộc nguồn vốn',
    fundPlan: 'Thuộc kế hoạch vốn',
    yearKhv: 'Năm KHV',
    projectApprove: 'Dự án duyệt hoặc GT trúng thầu / GT hợp đồng',
    accumFundAdvance: 'Lũy kế số vốn đã thanh toán từ khởi công đến cuối kỳ trước',
    nameDvth: 'Tên ĐVTH',
    accountDvth: 'Số tài khoản ĐVTH',
    bankCode: 'Mã NH, KB',
  },
  detailTab: {
  },
  contentAlertCompareTotalAmountGeneralVsDetail: 'Tổng số tiền đề nghị tạm ứng, thanh toán phải bằng tổng số tiền các dòng chi tiết. Vui lòng xem lại.',
  titleAlertCompareTotalAmountGeneralVsDetail: 'Không hợp lệ',
  contentGeneratePaymentVoucher: 'Bạn cần chọn ít nhất 1 dòng chứng từ',
  contentNeedChooseOne: 'Bạn cần chọn ít nhất 1 dòng'
};
